module.exports = __webpack_public_path__ + "static/img/login-bg.2f1c4a4c.png";